export const BankNames = [
  {
    label: 'ABSA',
    value: 'ABSA'
  },
  {
    label: 'African Bank',
    value: 'African Bank'
  },
  {
    label: 'Bidvest',
    value: 'Bidvest'
  },
  {
    label: 'Capitec',
    value: 'Capitec'
  },
  {
    label: 'Discovery',
    value: 'Discovery'
  },
  {
    label: 'FNB',
    value: 'FNB'
  },
  {
    label: 'Investec',
    value: 'Investec'
  },
  {
    label: 'Nedbank',
    value: 'Nedbank'
  },
  {
    label: 'RMB',
    value: 'RMB'
  },
  {
    label: 'Sasfin',
    value: 'Sasfin'
  },
  {
    label: 'Standard Bank',
    value: 'Standard Bank'
  },
  {
    label: 'Tyme Bank',
    value: 'Tyme Bank'
  },
  {
    label: 'Other',
    value: 'Other'
  }
].sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
